import React from 'react';
import { ErrorModal as ErrorModalType } from '@/types/modal';
import { ErrorModal } from '@/components/molecules/common/Modal';

const View: React.FC<{ modal: ErrorModalType }> = ({ modal }) => {
  return (
    <ErrorModal
      title={modal.title}
      error={modal.error}
      message={modal.message}
      onClose={modal.onClose}
    />
  );
};

export default View;
